import React, { Component } from "react";
import "../css/host.css";
import Quote from "../components/quote";
import OnlineBookings from "../components/host/onlinebookings";
import Phone from "../components/host/phone";
import SimplyServeSmall from "../images/SimplyServeSmall.png";
import Walkin from "../components/host/walkin";
import ReactGA from "react-ga";

class Value extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  state = {
    page: "", //select, values, features
  };
  render() {
    const value = (
      <React.Fragment>
        <Quote text="I was amazed to learn how many more diners we could have been seating every week." />
        <OnlineBookings maxWidth={this.props.maxWidth} />
        <Phone maxWidth={this.props.maxWidth} />
        <Walkin maxWidth={this.props.maxWidth} />
      </React.Fragment>
    );

    return (
      <div className="page host">
        <div className="page-title">
          SimplyServe
          <img src={SimplyServeSmall} alt="logo" />
          <div className="page-sub-title">let's take a look</div>
        </div>
        <div className="message-container" style={{}}>
          <div className="message" style={{ maxWidth: this.props.maxWidth }}>
            {/* <div className="title">
              <h2>Hi, I'm Chris</h2>
            </div>
            <div className="picture">
              <img src={Chris} alt="Chris" />
            </div>
            <div className="subtitle">
              <h4>founder of SimplyServe</h4>
            </div> */}

            <div className="content-wrapper">
              <div className="content">{value}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Value;
